import { Chip } from "@mui/material";
import React, {useMemo, memo} from "react";
import GaugeChart from "react-gauge-chart";

const chipStyle = {
  color: "#d3f4fe",
  minWidth: '50px',       
};

const PM10KPI = memo(({avgTemp,maxTemp,minTemp}) => {
 
  // Good: 3, Moderate: 2 and Poor: 1

 const percentage = useMemo(()=>{
  
  if (avgTemp >100  && avgTemp <=500) return 0.2;
  if (avgTemp > 50 && avgTemp <= 100) return 0.5;
  if (avgTemp >= 0 && avgTemp <= 50) return 0.8;
  
  return 0.2; 

},[avgTemp])

  return (
    <>
      <GaugeChart
        id="gauge-chart4"
        animate={false}
        arcsLength={[0.1,0.1,0.1]}
        colors={["red","yellow","#82f61d"]}
        arcPadding={0.1}
        cornerRadius={4}
        percent={percentage}
        hideText={true}
        style={{ width: "110px" }}
        className="dashboard-health-title"
      />
      <span>{avgTemp} μ g/m ³</span>
      <p className="card-value">PM10</p>
      <div className="d-flex flex-column justify-content-start align-items-start gap-2">
        <div className="d-flex justify-content-center align-items-center card-value">
          <Chip label="Max"  sx={chipStyle} />
          <p className="m-1 p-0">{maxTemp}</p>
        </div>
        <div className="d-flex justify-content-center card-value">
          <Chip label="Min" sx={chipStyle}  />
          <p className="m-1 p-0">{minTemp}</p>
        </div>
      </div>
     
    </>
  );
});

export default PM10KPI;
